module.exports = __webpack_public_path__ + "img/gain1-min.fa26fdc2.png";